<template>
  <div class="column" :class="'column-status-' + status" @added="draggedInto">
    <div class="col-list-container">
      <div v-if="selectedDeals.length > 0" class="alert alert-light" role="alert">
        <a class="link" @click="checkAll">выделить все</a>
        <a class="link float-right" @click="unCheckAll">снять все</a>
      </div>
      <h5>{{ title }}</h5>
      <div class="alert alert-light" role="alert">Сделок: {{ totalCount }} {{ totalAmount ? ('на сумму: ' + totalAmount) : '' }}</div>
      <div
        v-for="deal in deals"
        :key="deal.id"
        :data-id="deal.id"
        class="draggable-card"
      >
        <deal-card :deal="deal" @checkDeal="checkDeal" :checked="selectedDeals.indexOf(deal.id) >= 0" />
      </div>
      <div v-if="deals.length < total" class="more-btn">
        <b-button size="sm" class="btn-block" @click.prevent="$emit('nextPage');">Еще</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import DealCard from "./DealCard";
export default {
  name: 'board-column',
  components: { DealCard },
  props: {
    title: String,
    deals: Array,
    status: String,
    total: Number,
    amount: Number,
    selectedDeals: Array,
  },
  methods: {
    draggedInto(ids) {
      //console.log(ids);
      this.$emit('draggedInto', ids.detail.ids);
    },
    checkDeal(value) {
      this.$emit('checkDeal', value);
    },
    checkAll() {
      this.$emit('checkDealColumn', { status: this.status, checked: true })
    },
    unCheckAll() {
      this.$emit('checkDealColumn', { status: this.status, checked: false })
    }
  },
  computed: {
    totalAmount() {
      //let total = 0.0;
      //for (let deal of this.deals) {
      //  if (!isNaN(parseFloat(deal.amount)))
      //    total += parseFloat(deal.amount);
      //}
      //if (isNaN(total))
      //  total = 0.0;
      //return Intl.NumberFormat('ru-RU', {style: 'currency', currency: 'RUB'}).format(total)
      return Intl.NumberFormat('ru-RU', {style: 'currency', currency: 'RUB'}).format(this.amount)
    },
    totalCount() {
      //return this.deals.length;
      return this.total;
    },
  }
}
</script>
<style scoped lang="scss">
.column {
  display: flex;
  flex-direction: column;
  align-self: auto;
  min-width: 300px;
  max-width: 300px;
  flex: 1 1 auto;
  min-height: 70vh;

  .col-list-container {
    margin-left: 6px;
    margin-right: 6px;
    display: flex;
    flex-direction: column;
    align-self: auto;
    min-width: 288px;
    max-width: 288px;
    border-radius: 6px;
    flex: 1 1 auto;
    padding: 7px;
    background-color: rgb(244, 245, 247);
    position: relative;
    transition: opacity 0.2s ease 0s;
  }

  &[aria-dropeffect="move"] {
    .col-list-container {
      border-color: #68b;
    }

    &:focus, &.dragover {
      .col-list-container {
        outline: none;
        box-shadow: 0 0 0 1px #fff, 0 0 0 3px #68b;
      }
    }
  }
}

h5 {
  font-size: 18px;
  margin: 10px 5px 10px;
}

.col-list-container .alert {
  margin: 5px 5px 10px;
}

.draggable-card {
  margin-bottom: 5px;
  padding: 0.2em 0.4em;
  border-radius: 0.2em;
  line-height: 1.3;

  &:hover {
    .deal-card {
      box-shadow: 0 0 0 2px #68b, inset 0 0 0 1px #ddd;
    }
  }

  &:focus {
    outline: none;

    .deal-card {
      outline: none;
      box-shadow: 0 0 0 2px #68b, inset 0 0 0 1px #ddd;
    }
  }
}
.more-btn{
  margin-bottom: 5px;
  padding: 0.2em 0.4em;
}
@keyframes nodeInserted {
  from {
    opacity: 0.2;
  }
  to {
    opacity: 0.8;
  }
}

.item-dropzone-area {
  height: 2rem;
  background: #888;
  opacity: 0.8;
  animation-duration: 0.5s;
  animation-name: nodeInserted;
}

.link {
  cursor: pointer;
}
</style>
